import FixedFooterButton from './FixedFooterButton';

export default FixedFooterButton;
